<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle" id="halftitle1"><a id="page_xxi"><strong>Howard Zinn’s Southern Diary</strong></a><a id="page_xxii"></a></p><a id="page_xxii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?581f4604